






















































import { isEqual } from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'

import BlackWhiteList from '../../../BlackWhiteList/BlackWhiteList.vue'
import { BlackWhiteListItem } from "../../../BlackWhiteList/types";
import DefaultValueWrapper from '../../../DefaultValueWrapper.vue'
import SettingWrapper from "../../../SettingWrapper.vue";
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput } from '../../mixins'
import { BlackWhiteListInputSettings } from './types';

@Component({
  components: {
    SettingWrapper,
    DefaultValueWrapper,
    BlackWhiteList,
    FieldWrapper,
  },
})
export default class BlackWhiteListInput extends Mixins(BaseInput) {

  get blackWhiteListSettings() {
    return this.settings as BlackWhiteListInputSettings
  }

  updateModel<T extends keyof BlackWhiteListItem<string>>(data: { field: T, value: BlackWhiteListItem<string>[T]}) {
    this.value[data.field] = data.value

    this.setValue(this.value)
  }

  mounted() {
    if (this.settings.settingWrapper !== undefined) {
      this.disabledSettingValueActive = isEqual(this.disabledOrActiveValue, this.value) || ((this.$slots['value-stub'] ?? false) && isEqual(this.disabledOrActiveValue, this.value))
    }
  }
}
